<template>
  <div class="info-box">
    <el-segmented
      v-model="state.params.signin_status"
      size="large"
      :options="[
        { value: 0, label: '待签到' },
        { value: 1, label: '已签到' },
      ]"
      :block="false"
      class="c-segmented w-40 m-auto"
      @change="onLoad()"
    />
    <div class="flex-1 gap-x-5 overflow-hidden flex flex-col mt-2">
      <div class="flex gap-x-2 whitespace-nowrap items-center">
        <el-input
          v-model="state.params.keywords"
          class="c-search-white"
          clearable
          placeholder="关键字"
          @keyup.enter="onLoad()"
          @clear="onLoad()"
        >
          <template #suffix>
            <el-icon
              @click="onLoad()"
              color="#a2a2a2"
              title="搜索"
              class="font-bold cursor-pointer hover:opacity-60"
              ><Search
            /></el-icon>
          </template>
        </el-input>
        <strong class="ml-2">只看嘉宾</strong
        ><el-switch v-model="state.show_jiabin" @change="onLoad()" />
      </div>
      <template v-if="state.list_data?.length > 0">
        <div class="overflow-y-auto flex flex-col gap-y-2">
          <div
            v-for="item in state.list_data"
            :key="item"
            class="flex items-center p-2.5 rounded-lg gap-x-3 hover:opacity-60 cursor-pointer bg-white"
            @click="onSelect(item)"
          >
            <c_Avatar
              v-if="item.id"
              :file_url="item.conferee?.avatar_attachment?.file_url"
              :size="10"
              :title="item.conferee?.name?.slice(0, 1)"
            />
            <div class="flex-1">
              <ul class="flex items-center">
                <li class="flex-1 gap-x-3 flex items-center">
                  <strong
                    style="color: var(--el-color-primary)"
                    class="cursor-pointer hover:underline"
                  >
                    {{ item.conferee?.name }}
                  </strong>
                  <c_sex :value="item.conferee?.sex" />
                  <text class="text-sm text-gray-400">{{
                    $phoneFormat(item.conferee?.phone)
                  }}</text>
                </li>
              </ul>
              <ul class="flex flex-wrap gap-x-2 gap-y-1">
                {{
                  item.d_attend_role_name
                }}
                <!-- <el-tag
                  type="info"
                  size="small"
                  v-for="item in item.d_conferee_tag_json_arr"
                  :key="item"
                >
                  {{ item }}
                </el-tag> -->
              </ul>
            </div>
            <!-- <el-icon
              v-if="state.select_data?.some((w) => w.id == item.id)"
              color="#080"
              :size="16"
            >
              <Select />
            </el-icon> -->
            <el-button
              v-if="state.params.signin_status == 0"
              type="primary"
              size="small"
              icon="EditPen"
              link
              @click="onSignin(item)"
            >
              标记签到
            </el-button>
          </div>
        </div>
        <div class="flex justify-center">
          <el-pagination
            layout="prev, pager, next"
            :total="state.totalCount"
            :background="false"
            size="small"
            :default-page-size="20"
            style="
              --el-pagination-bg-color: transparent;
              --el-pagination-button-disabled-bg-color: transparent;
            "
          />
        </div>
      </template>
      <div class="text-center" v-else>
        <el-image :src="require('@/assets/images/nodata.png')" />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_service_signin_attendee_page,
  meeting_service_signin_dealSignin,
} from "@/http/meetingservice";
import { ElMessageBox, ElMessage } from "element-plus";

class InitFormData {
  params = {
    page: 1,
    signin_status: 0,
  };
}

export default {
  props: {
    meeting_schedule_id: Number, //日程Id
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_schedule_id = props.meeting_schedule_id;
      onLoad();
    });

    const onLoad = () => {
      if (state.show_jiabin) state.params.attend_type = 1;
      else delete state.params.attend_type;

      meeting_service_signin_attendee_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    const onSignin = (item) => {
      ElMessageBox.confirm(
        `您确定把<strong style="color: #1e90ff;">${item.attend_type_name}-${item.conferee?.name}</strong>的签到状态标记为<strong style='color: #080;'>已签到</strong>吗？`,
        "标记签到",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_service_signin_dealSignin({
          meeting_schedule_id: props.meeting_schedule_id,
          meeting_attendee_id: item.id,
          signin_status: 1,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success("标记签到成功");
            onLoad();
          }
        });
      });
    };

    return { state, onLoad, onSignin };
  },
};
</script>

<style lang="less" scoped></style>
